import React, {useRef, useEffect, useState,Suspense } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "./Main.scss";
// import Logo from './assets/images/logo.png';
import Logo from './assets/images/logo-appluss.png';
// import FingerprintJS from '@fingerprintjs/fingerprintjs'

import {
    Home,
    StoreDetail,
    Store,
    Scan,
    Map,
    Profile,
    Customer,
    Login,
    Malls,
    Events,
    Service,
    Verify,
    EventDetail,
    ServiceDetail,
    ServiceLand,
    Notif, Festival, FestivalDetail, Report, Chat, Chat2,
    Menu, Land, NotificationCenter,
    OnlineStore,
    OnlineStoreCat,
    OnlineProduct,
    Basket,
    SendInfo,
    Payment,
    Address, OnlineOrderList, OnlineOrderDetail
} from "./Pages";
import {Route, useHistory, useLocation, withRouter} from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import 'toasted-notes/src/styles.css';
import "./pageTransitions/slideTransition.scss";
import {SideBar} from "./Components/Sidebar/SideBar.js";
import {
    useDispatchBasket,
    useDispatchMall,
    useDispatchPrompt, useDispatchResp,
    useDispatchRoot,
    useDispatchStore, useDispatchUser, useMall,
    usePrompt, useResp,
    useStore
} from "./hooks";


import {VerifyCustomer} from "./Pages/VerifyCustomer/VerifyCustomer";
import {Download} from "./Pages/Download/Download";
import {NotificationAllow} from "./Components";
import ReactGA from 'react-ga';
import {LocalPush} from "./Services";
import {OnlineStoreSubCat} from "./Pages/OnlineStoreSubCat/OnlineStoreSubCat";
import {PromptProvider} from "./providers";
import Ribbon from "./Components/OnlineSwiper/Riboon";
import {Coupon} from "./Pages/Coupon/Coupon";
import {Gate} from "./Pages/Gate/Gate";
import {Orders} from "./Pages/Orders/Orders";
import {OrderDetail} from "./Pages/Orders/OrderDetail";
import {InvoiceDetail} from "./Pages/Orders/InvoiceDetail";
import {Cat_Clothing} from "./Pages/Clothing/Cat_Clothing/Cat_Clothing";
import {Referral} from "./Pages/Referral/Referral";
import {ReferralLand} from "./Pages/Referral/ReferralLand";
import {List_Clothing} from "./Pages/Clothing/List_Clothing/List_Clothing";
import {Product_Clothing} from "./Pages/Clothing/Product_Clothing/Product_Clothing";
import {InvoiceCreate} from "./Pages/InvoiceCreate/InvoiceCreate";
import CheckDomain from "./Components/CheckDomain/CheckDomain";
import Reward from "./Pages/Reward/Reward";
import Awards from "./Pages/Awards/Awards";
import Transactions from "./Pages/Transactions/Transactions";
import Invoice from "./Pages/Invoice/Invoice";
import Exa from "./Pages/exa/Exa";
import {OnStore} from "./Pages/OnStore/OnStore";
import {Contacts} from "./Pages/Referral/Contacts";
import {ReferralCamp} from "./Pages/Referral/ReferralCamp";
import MallLand from "./Pages/MallLand/MallLand";
import {Blog} from "./Pages/Blog/Blog";
import {BlogLand} from "./Pages/BlogDetail/BlogLand";
import InfluencerLand from "./Pages/Referral/InfluencerLand";
import {Chart} from "./Pages/Chart/Chart";
import InnerLand from "./Pages/InnerLand/InnerLand";
import {Faq} from "./Pages/Faq/Faq";
import HomeResponsive from "./Pages/HomeResponsive/HomeResponsive";
import Results from "./Pages/Results/Results";
import {BasketInvoice} from "./Pages/BasketInvoice/BasketInvoice";
import {SendInfoInvoice} from "./Pages/SendInfoInvoice/SendInfoInvoice";
import Requests from "./Pages/Requests/Requests";
import RequestsDetail from "./Pages/RequestsDetail/RequestsDetail";
import useWindowDimensions from "./hooks/useWindowDimensions";
import ShopSearch from "./Pages/ShopSearch/ShopSearch";
import Dispatcher from "./Pages/Dispatcher/Dispatcher";
import {AccessTokenData} from "./Pages/Customer/CustomerServices";
import OnlineOrders from "./Pages/OnlineOrders/OnlineOrders";
import CampaignDesktop from "./Pages/CampaignDesktop/CampaignDesktop";
import CampaignDetailDesktop from "./Pages/CampaignDetailDesktop/CampaignDetailDesktop";


const StyleShopHome = React.lazy(() => import('./Pages/StyleShop/StyleShopHome/StyleShopHome'));
const StyleShopList = React.lazy(() => import('./Pages/StyleShop/StyleShopList/StyleShopList'));
const StyleShopProduct = React.lazy(() => import('./Pages/StyleShop/StyleShopProduct/StyleShopProduct'));
const StyleShopBasket = React.lazy(() => import('./Pages/StyleShop/StyleShopBasket/StyleShopBasket'));
const Slug = React.lazy(() => import('./Pages/Slug/Slug'));
const About = React.lazy(() => import('./Pages/About/About'));
const Otp = React.lazy(() => import('./Pages/Otp/Otp'));

const DirectInvoice = React.lazy(() => import('./Pages/DirectInvoice/DirectInvoice'));
const UnAuth = React.lazy(() => import('./Pages/unAuth/UnAuth'));

//guides
const ShopGuid = React.lazy(() => import('./Pages/ShopGuid/ShopGuid'));
const TermsGuid = React.lazy(() => import('./Pages/TermsGuid/TermsGuid'));
const SendGuid = React.lazy(() => import('./Pages/SendGuid/SendGuid'));
const PaymentGuid = React.lazy(() => import('./Pages/PaymentGuid/PaymentGuid'));
const ReturnedGuid = React.lazy(() => import('./Pages/ReturnedGuid/ReturnedGuid'));
const UseGuid = React.lazy(() => import('./Pages/UseGuid/UseGuid'));
const PrivacyPolicy = React.lazy(() => import('./Pages/PrivacyPolicy/PrivacyPolicy'));

const Med = React.lazy(() => import('./Pages/Med/Med'));

//dr shop
const DrShopMain = React.lazy(() => import('./Pages/DrShop/DrShopMain/DrShopMain'));
const DrShopFilter = React.lazy(() => import('./Pages/DrShop/DrShopFilter/DrShopFilter'));
const DrShopDetail = React.lazy(() => import('./Pages/DrShop/DrShopDetail/DrShopDetail'));
const DrShopBasket = React.lazy(() => import('./Pages/DrShop/DrShopBasket/DrShopBasket'));
const DrShopInfo = React.lazy(() => import('./Pages/DrShop/DrShopInfo/DrShopInfo'));
const DrShopSend = React.lazy(() => import('./Pages/DrShop/DrShopSend/DrShopSend'));
const DrShopPreInvoice = React.lazy(() => import('./Pages/DrShop/DrShopPreInvoice/DrShopPreInvoice'));
const DrShopPay = React.lazy(() => import('./Pages/DrShop/DrShopPay/DrShopPay'));
const DrShopCallBack = React.lazy(() => import('./Pages/DrShop/DrShopCallBack/DrShopCallBack'));
const BlogsDesktop = React.lazy(() => import('./Pages/BlogsDesktop/BlogsDesktop'));
const BookingDesktop = React.lazy(() => import('./Pages/BookingDesktop/BookingDesktop'));

// const fpPromise = FingerprintJS.load()

function OverSize() {
    return(
        <div id="overSize-container">
            <img src="/other/vertical_mobile.png" alt=""/>
            <span>لطفا گوشی را به حالت عمودی برگردانید</span>
        </div>
    )
}


const desktop_pages = [
    'home',
    'online-store-product',
    'online-store',
    'shop',
    'referral',
    'shop-guid',
    'terms-guid',
    'send-guid',
    'returned-guid',
    'use-guid',
    'payment-guid',
    'privacy-policy',
    'online-store-basket',
    'online-store-sendinfo',
    'online-store-payment',
    'online-store-gateway',
    'online-store-address',
    'dr-shop',
    'login',
    'verify',
    'profile',
    'reward',
    'online-orders',
    'blog',
    'med-order',
    'booking',
    'campaigns',
    'festivals',
    'festival-detail',
    'awards',
    ''
]

const AnyRoute = ()=>{
    const location = useLocation();
    const setUser = useDispatchUser();
    useEffect(()=>{
        let search = new URLSearchParams(location.search)
        let token = search.get('token');
        if(token)
            getAccess(token)
    },[])

    const getAccess =async (t)=>{
        try{
            let response = await AccessTokenData(t);
            localStorage.setItem("token", response.data.user.access_token);
            localStorage.setItem('user',JSON.stringify(response.data.user));
            setUser(response.data.user);
        }catch (e) {
            console.log(e)
        }
    }


    return(
        <div>
            <h1>fkdlfkgdlfkg</h1>
        </div>
    )
}

function MainContainer({responsive}){
    return(
        <div className="main_container" id="App">
            <SideBar pageWrapId={"page-wrap"} outerContainerId={"App"} responsive={responsive} />
            <div id="page-wrap">
                {/*Protected Route*/}
                {/*<ProtectedRoute  path='/' exact component={Home} />*/}
                {/*<ProtectedRoute      path='/home' exact component={Home} />*/}

                <Route  path='/' exact component={Dispatcher} />
                <Route  path='/home' exact component={Home} />

                {/*Guides*/}
                <Route  path='/shop-guid' exact component={ShopGuid} />
                <Route  path='/terms-guid' exact component={TermsGuid} />
                <Route  path='/send-guid' exact component={SendGuid} />
                <Route  path='/payment-guid' exact component={PaymentGuid} />
                <Route  path='/returned-guid' exact component={ReturnedGuid} />
                <Route  path='/use-guid' exact component={UseGuid} />
                <Route  path='/privacy-policy' exact component={PrivacyPolicy} />

                {/*Med order*/}
                <ProtectedRoute  path='/med-order' exact component={Med} />


                <Route  path='/about' exact component={About} />
                <ProtectedRoute  path='/store' component={Store} />
                <ProtectedRoute  path='/on-store' component={OnStore} />
                <ProtectedRoute  path='/scan' component={Scan} />
                <ProtectedRoute  path='/map' component={Map} />
                <ProtectedRoute  path='/profile' component={Profile} />
                <ProtectedRoute  path='/reward' component={Reward} />
                <ProtectedRoute  path='/online-orders' component={OnlineOrders} />
                <ProtectedRoute  path='/malls' component={Malls} />
                <ProtectedRoute  path='/store-detail/:id' component={StoreDetail} />
                <ProtectedRoute  path='/notifications' component={Notif} />
                <ProtectedRoute  path='/faq/:merchantId' component={Faq} />
                <ProtectedRoute  path='/festivals' component={Festival} />
                <ProtectedRoute  path='/campaigns' component={CampaignDesktop} />
                <ProtectedRoute  path='/festival-detail/:id' component={FestivalDetail} />
                <ProtectedRoute  path='/campaign-detail/:id' component={CampaignDetailDesktop} />
                <ProtectedRoute  path='/report/:id' component={Report} />
                <ProtectedRoute  path='/chat/:id' component={Chat} />
                <ProtectedRoute  path='/events' component={Events} />
                <ProtectedRoute  path='/Services' component={Service} />
                <ProtectedRoute  path='/Chart' component={Chart} />
                <ProtectedRoute  path='/awards' component={Awards} />
                <ProtectedRoute  path='/transactions' component={Transactions} />
                <ProtectedRoute  path='/event-detail/:id' component={EventDetail} />
                <ProtectedRoute  path='/service-detail/:id' component={ServiceLand} />
                <ProtectedRoute  path='/blog-detail/:id' component={BlogLand} />
                <Route  path='/blogs' component={Blog} />
                <Route  path='/blog/:id' component={BlogsDesktop} />
                <Route  path='/booking/:id' component={BookingDesktop} />
                <Route  path='/chat2/:id' component={Chat2} />
                <ProtectedRoute  path='/menu/:id' component={Menu} />

                {/*New Public*/}
                <Route  path='/dr-shop/online-store/:metId' component={OnlineStore} />
                <Route  path='/online-store-categories/:merchantId/:catId' component={OnlineStoreCat} />
                <Route  path='/online-store-sub-categories/:merchantId/:catId' component={OnlineStoreSubCat} />

                {/*Dr Shop*/}
                <Route  path='/dr-shop/main/:merchantId' exact component={DrShopMain} />
                <Route  path='/dr-shop/search/:merchantId/:catId' exact  component={DrShopFilter} />
                <Route  path='/dr-shop/detail/:merchantId/:productId' exact  component={DrShopDetail} />
                <Route  path='/dr-shop/basket/:merchantId' exact  component={DrShopBasket} />
                <Route  path='/dr-shop/info/:merchantId' exact  component={DrShopInfo} />
                <Route  path='/dr-shop/send/:merchantId' exact  component={DrShopSend} />
                <Route  path='/dr-shop/preinvoice/:merchantId' exact  component={DrShopPreInvoice} />
                <Route  path='/dr-shop/pay/:merchantId' exact  component={DrShopPay} />
                <Route  path='/dr-shop/bank-result/:id' exact  component={DrShopCallBack} />


                {/*<ProtectedRoute  path='/online-store-product/:merchantId/:productId' component={OnlineProduct} />*/}
                <Route  path='/online-store-basket' component={Basket} />
                <ProtectedRoute  path='/online-store-sendinfo' component={SendInfo} />
                <ProtectedRoute  path='/online-store-payment' component={Payment} />
                <ProtectedRoute  path='/online-store-gateway' component={Gate} />
                <ProtectedRoute  path='/online-store-address' component={Address} />

                <ProtectedRoute  path='/exa' component={Exa} />

                <ProtectedRoute  path='/online-order-list' component={OnlineOrderList} />
                <ProtectedRoute  path='/orders' component={Orders} />
                <ProtectedRoute  path='/orders-detail/:id' component={OrderDetail} />
                <ProtectedRoute  path='/invoice-detail/:id' component={InvoiceDetail} />
                {/*Referral Route*/}
                <ProtectedRoute  path='/referral/:id' component={Referral} />
                <ProtectedRoute  path='/referral-camp/:id' component={ReferralCamp} />
                <Route  path='/referral-land/:merchantId/:referralId' component={ReferralLand} />
                <Route  path='/ref_link/:linkUid/:resourceType/:resourceUid/:influencerUid' component={InfluencerLand} />
                {/*Clothing Route*/}
                <ProtectedRoute  path='/online-clothing/:merchantId' component={Cat_Clothing} />
                <ProtectedRoute  path='/online-clothing-list/:merchantId/:catId' component={List_Clothing} />
                <ProtectedRoute  path='/online-clothing-product/:merchantId/:productId' component={Product_Clothing} />
                <ProtectedRoute  path='/results' component={Results} />
                <ProtectedRoute  path='/requests' component={Requests} />
                <ProtectedRoute  path='/requests-detail/:id' component={RequestsDetail} />

                {/*shop search*/}
                <Route  path='/shop/:id/:catId' component={ShopSearch} />



                {/*Style Shop*/}
                <Route  path='/online-style-shop/:merchantId' component={StyleShopHome} />
                <Route  path='/online-style-shop-list/:merchantId/:catId' component={StyleShopList} />
                <Route  path='/online-style-shop-product/:merchantId/:productId' component={StyleShopProduct} />
                <Route  path='/online-style-shop-basket' component={StyleShopBasket} />
                <Route  path='/contacts' component={Contacts} />


                <Route  path='/m/:merchantSlug/p/:pageSlug' component={Slug} />
                {/*Direct Invoice*/}
                <Route  path='/direct-invoice/:token' component={DirectInvoice} />
                <Route  path='/auth/:mallUid' component={UnAuth} />
                <Route  path='/create-invoice' component={InvoiceCreate} />
                {/*Public Route*/}
                <Route path='/invoice/:token' component={Invoice} />
                <Route path='/customer' component={Customer} />
                <Route path={"/verify"} component={Verify}/>
                <Route path={"/verify-customer"} component={VerifyCustomer}/>
                <Route path={"/login"} component={Login}/>
                <Route path={"/otp"} component={Otp}/>
                <Route path={"/download/*"} component={Download}/>
                <Route path={"/qr/:slug"} component={Land}/>
                <Route path={"/social/:slug"} component={Land}/>
                <Route path={"/notification/:page/:id"} component={NotificationCenter}/>
                <Route path='/:slug(@[0-9a-zA-Z_-]{0,50})' exact component={Land}/>
                <Route path='/ribbon/:id'  component={Ribbon}/>
                <Route path='/coupon/:couponId'  component={Coupon}/>
                <Route  path='/online-order-detail/:id' component={OnlineOrderDetail} />
                <Route  path='/online-store-product/:merchantId/:productId' component={OnlineProduct} />
                <Route  path='/land/:malliId/:merchantiId/:pageiId' component={MallLand} />
                <Route  path='/resp' component={HomeResponsive} />
                <ProtectedRoute  path='/page/:merchantiId/:pageiId' component={InnerLand} />

                <Route  path='/basket-order' component={BasketInvoice} />
                <Route  path='/send-info-invoice' component={SendInfoInvoice} />
            </div>

            {/*<NotificationAllow/>*/}
        </div>
    )
}



function App() {

    //hooks
    const setPrompt = useDispatchPrompt();
    const history = useHistory();
    const setSelect = useDispatchRoot();
    const setMall = useDispatchMall();
    const prompt = usePrompt();
    const inputRef = useRef(null)
    const fire = useStore();
    const setFire = useDispatchStore();
    const Mall = useMall();
    const basketDispatch = useDispatchBasket();

    //states -----
    const [body, setBody] = useState("nottt");
    const [toke, setToke] = useState("nottt");
    const { height, width,mobileWidth } = useWindowDimensions();


    useEffect(()=>{
        // console.log("sddddddddddd",width)
        adjustDesktopMode()
    },[width])




    useEffect(()=>{
        syncGustBasketWithContext()
        adjustDesktopMode()
    },[])


    useEffect(()=>{
        let mall_local = localStorage.getItem('mall')
        if(mall_local){
            let mall_obj = JSON.parse(mall_local)
            document.title = mall_obj.name;
        }

    })

    const syncGustBasketWithContext = ()=>{
        console.log("sync Basket with C")
        let token = localStorage.getItem('token');
        if(!token){
            let localBasket = localStorage.getItem('basket');
            if(localBasket){
                basketDispatch(JSON.parse(localBasket))
            }
        }

    }

    const adjustDesktopMode = ()=>{
        let wd = document.getElementsByTagName('body')[0].clientWidth
        // console.log("FFFFFFFFFFFFFFFFFFFFF L",window.location.pathname,wd)
        let routeTitle = window.location.pathname.split("/")[1]
        if(desktop_pages.includes(routeTitle) && wd>600){
            set_resp(true)
        } else{
            set_resp(false)
        }
    }


    useEffect(() => {
        // getFinger()
        const beforeInstallListener = e => {
            e.preventDefault();
            console.log("BEFORaE : ",e);
            setPrompt(e);
            setBody("install");
        };

        // console.log("App Init ...")


        window.addEventListener("beforeinstallprompt", beforeInstallListener);

        navigator.serviceWorker.addEventListener("message", (message) => {
            try{
                // console.log(message.data);
                // setBody(JSON.stringify(message.data));
                let notif = message.data["firebase-messaging-msg-data"].notification;
                // console.log(notif)
                LocalPush({title:notif.title,body:notif.body,image:notif.image,url:notif.click_action})
            }catch (e) {
                // setBody(JSON.stringify(e));
                // console.log(e)
            }
        });

        let uid = "0"
        let cId = "0"
        let user = localStorage.getItem('user');
        if(user) {
            let parsed_user = JSON.parse(user);
            uid = parsed_user.uid;
            cId = parsed_user.phone
        }

        ReactGA.initialize('UA-175496552-1', {
            debug: false,
            titleCase: false,
            gaOptions: {
                userId: uid,
                clientId: cId
            }
        });


        // const trackingId = "UA-175496552-1"; // Replace with your Google Analytics tracking ID
        // ReactGA.initialize(trackingId);
        // ReactGA.initialize('UA-175496552-1', {
        //     debug: true,
        //     titleCase: false,
        //     gaOptions: {
        //         userId: 123,
        //         clientId: 'some-unique-id'
        //     }
        // });

        history.listen(location => {
            setSelect(location.pathname);
            adjustDesktopMode(location)
            ReactGA.set({ page: location.pathname }); // Update the user's current page
            ReactGA.pageview(location.pathname); // Record a pageview for the given page
        });

    }, [])




    // const getFinger = async ()=>{
    //     const fp = await fpPromise
    //     const result = await fp.get()
    //
    //     // This is the visitor identifier:
    //     const visitorId = result.visitorId
    //     console.log("finger : ",visitorId)
    // }

    const resp = useResp();
    const set_resp = useDispatchResp();

    const desktopMode = ()=>{
        set_resp(true);
    }

    const mobileMode = ()=>{
        set_resp(false);
    }

    const checkDesktopBtn = ()=>{
        let currentPath = window.location.pathname;
        let routeTitle = currentPath.split("/")[1]
        return desktop_pages.includes(routeTitle)
    }




    return (
        <>
            {resp===false?
                <div className="master-sec">
                <div className="desk-sec">
                    <img src={Logo} alt=""/>
                    <span>برای استفاده از تمام ویژگی های اپلیکیشن </span>
                    <span> و نمایش بهتر از موبایل استفاده نمایید</span>
                    {/*{checkDesktopBtn()?<span onClick={e=>desktopMode()} className="desktop-mode-btn">حالت دسکتاپ</span>:null}*/}
                </div>
                <div className="mobile-sec" id="mobile-sec" >
                    <Suspense fallback={<div>...</div>}>
                        <MainContainer responsive={resp}/>
                    </Suspense>
                </div>
            </div>:null}
            {resp===true?<div>
                {/*<div className="mobile-mode-btn" onClick={e=>mobileMode()}>*/}
                {/*    <span>حالت مویایل</span>*/}
                {/*</div>*/}
                <Suspense fallback={<div>...</div>}>
                    <MainContainer responsive={resp}/>
                </Suspense>
            </div>:null
            }
            </>

    );
}

export default withRouter(App);

